module.exports = __webpack_public_path__ + "static/media/gh.c41e6092.png";